<script setup lang="ts">
import type { NamedTracker } from '@/utils/named-tracker-set';
import NamedTrackerRoster from '@/components/shipment/shared/NamedTrackerRoster.vue';

defineProps<{
  trackers: NamedTracker[] | null;
  screenPoint: { x: number; y: number } | null;
}>();
</script>

<template>
  <div
    v-if="trackers?.length && screenPoint"
    class="pointer-events-none absolute z-20"
    :style="{
      left: `${screenPoint.x}px`,
      top: `${screenPoint.y}px`,
      transform: 'translate(12px, 8px)',
    }"
    role="tooltip"
  >
    <div
      class="max-h-[min(20rem,50vh)] overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black/5"
    >
      <NamedTrackerRoster :trackers="trackers ?? []" />
    </div>
  </div>
</template>
